import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NetPromoterScoreReportState } from '@core/store';

export const netPromoterScoreReportState = createFeatureSelector('netPromoterScoreReport');

export const getNetPromoterScoreReportState = createSelector(
    netPromoterScoreReportState,
    (state: NetPromoterScoreReportState) => state
);
